import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "appContainer" }
const _hoisted_2 = { className: "box" }
const _hoisted_3 = { className: "box-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Urgent ")
const _hoisted_5 = { class: "app-help" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Type the ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "app-copy-text" }, "@", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" character")
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" to suggest mentions. ")
const _hoisted_11 = /*#__PURE__*/_createStaticVNode(" Try mentioning the following: <ul><li>Cost centers like <span class=\"app-copy-text\">@102</span></li><li>Other tasks like <span class=\"app-copy-text\">@100-T02</span></li><li>People like <span class=\"app-copy-text\">@Mick</span></li><li> Dates: <ul><li><span class=\"app-copy-text\">@today</span>, <span class=\"app-copy-text\">@tomorrow</span> or <span class=\"app-copy-text\">@yesterday</span></li><li><span class=\"app-copy-text\">@Tuesday</span></li><li><span class=\"app-copy-text\">@next Wednesday</span> or <span class=\"app-copy-text\">@last Friday</span></li><li><span class=\"app-copy-text\">@+2 days</span> or <span class=\"app-copy-text\">@-15 days</span></li></ul></li></ul>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAutocompleteTextarea = _resolveComponent("AppAutocompleteTextarea")!
  const _component_o_switch = _resolveComponent("o-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AppAutocompleteTextarea, {
          modelValue: _ctx.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
          taclass: "title-textbox",
          wrapperClass: " ",
          maxLength: 255,
          defaultTop: 40,
          taid: "app-textarea-title",
          allowNl: false
        }, null, 8, ["modelValue"]),
        _createVNode(_component_AppAutocompleteTextarea, {
          ref: "autoDescription",
          modelValue: _ctx.description,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
          taclass: "box-textbox",
          wrapperClass: "box-compose",
          maxLength: 4096,
          defaultTop: 270,
          taid: "app-textarea-description",
          allowNl: true
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_o_switch, {
              modelValue: _ctx.urgent,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.urgent) = $event)),
              variant: "danger"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "save-button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, " Save ")
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.insert(' @')), ["prevent"]))
        }, _hoisted_9),
        _hoisted_10
      ]),
      _hoisted_11
    ])
  ], 64))
}